import react from "react";

import NFMinime1 from "../images/commercials/NFKids/01THENORTHFACEKIDS Large.jpeg";
import NFMinime2 from "../images/commercials/NFKids/02THENORTHFACEKIDS Large.jpeg";
import NFMinime3 from "../images/commercials/NFKids/03THENORTHFACEKIDS Large.jpeg";
import NFMinime4 from "../images/commercials/NFKids/04THENORTHFACEKIDS Large.jpeg";
import NFMinime5 from "../images/commercials/NFKids/06THENORTHFACEKIDS Large.jpeg";
import NFMinime6 from "../images/commercials/NFKids/07THENORTHFACEKIDS Large.jpeg";
import NFMinime7 from "../images/commercials/NFKids/08THENORTHFACE Large.jpeg";
import NFMinime8 from "../images/commercials/NFKids/09THENORTHFACEKIDS Large.jpeg";
import NFMinime9 from "../images/commercials/NFKids/10THENORTHFACEKIDS Large.jpeg";
import NFMinime10 from "../images/commercials/NFKids/11THENORTHFACEKIDS Large.jpeg";
import NFMinime11 from "../images/commercials/NFKids/12THENORTHFACEKIDS Large.jpeg";

const NFMinime = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={NFMinime1} alt="North Face Kids - Image 1"/>
                </div>
                <div className="single portrait">
                    <img src={NFMinime2} alt="North Face Kids - Image 2"/>
                </div>
                <div className="single portrait">
                    <img src={NFMinime3} alt="North Face Kids - Image 3"/>
                </div>
                <div className="single portrait">
                    <img src={NFMinime4} alt="North Face Kids - Image 4"/>
                </div>
                <div className="single portrait">
                    <img src={NFMinime5} alt="North Face Kids - Image 5"/>
                </div>
                <div className="single portrait">
                    <img src={NFMinime6} alt="North Face Kids - Image 6"/>
                </div>
                <div className="single portrait">
                    <img src={NFMinime7} alt="North Face Kids - Image 7"/>
                </div>
                <div className="single portrait">
                    <img src={NFMinime8} alt="North Face Kids - Image 8"/>
                </div>
                <div className="single portrait">
                    <img src={NFMinime9} alt="North Face Kids - Image 9"/>
                </div>
                <div className="single portrait">
                    <img src={NFMinime10} alt="North Face Kids - Image 10"/>
                </div>
                <div className="single portrait">
                    <img src={NFMinime11} alt="North Face Kids - Image 11"/>
                </div>
            </div>
        </div>
    );
}

export default NFMinime;